import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 9l-3 3l-3 -3","key":"svg-0"}],["path",{"d":"M15 13l-3 3l-3 -3","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}]]

const IconCircleChevronsDown = createReactComponent('outline', 'circle-chevrons-down', 'CircleChevronsDown', __iconNode);

export default IconCircleChevronsDown;